import dayjs from '@localization-lib/date-time/dayjs'
import { createFeatureSelector, createSelector } from '@ngrx/store'
import { NotificationChunk } from '@platform-lib/notification/notification.model'
import { notificationEntryAdapter } from '@platform-lib/notification/redux/notification.adapter'
import {
    NotificationState,
    notificationFeatureKey,
} from '@platform-lib/notification/redux/notification.state'

export const selectNotificationState = createFeatureSelector<NotificationState>(
    notificationFeatureKey
)

const adapterSelectors = notificationEntryAdapter.getSelectors()

export const selectUnreadNotificationCount = createSelector(
    selectNotificationState,
    ({ count }) => count
)

export const selectOverlayEntries = createSelector(
    selectNotificationState,
    ({ overlayEntries }) => adapterSelectors.selectAll(overlayEntries)
)

export const selectOverlayEntryLoadingError = createSelector(
    selectNotificationState,
    (state) => state.overlayEntriesLoadingError
)

export const selectSelectableUseCase = createSelector(
    selectNotificationState,
    ({ selectableUseCases }) => selectableUseCases
)

export const selectFilterValues = createSelector(
    selectNotificationState,
    ({ filterValues }) => filterValues
)

export const selectOverlayNotificationCount = createSelector(
    selectOverlayEntries,
    (entries) => entries.length
)

export const selectPageEntriesAvailable = createSelector(
    selectNotificationState,
    ({ pageEntriesAvailable }) => pageEntriesAvailable
)

export const selectOverlayEntriesLimit = createSelector(
    selectNotificationState,
    ({ overlayEntriesLimit }) => overlayEntriesLimit
)

export const isLoadingEntries = createSelector(
    selectNotificationState,
    ({ overlayEntriesLoading }) => overlayEntriesLoading
)

export const selectPageEntries = createSelector(
    selectNotificationState,
    ({ pageEntries }) => adapterSelectors.selectAll(pageEntries)
)

export const selectAllNotificationsRead = createSelector(
    selectNotificationState,
    ({ allRead }) => allRead
)

export const isPageLoading = createSelector(
    selectNotificationState,
    ({ pageLoading }) => pageLoading
)

export const selectPageEntriesLoaded = createSelector(
    selectNotificationState,
    ({ pageEntriesLoaded }) => pageEntriesLoaded
)

export const selectPageLoadingError = createSelector(
    selectNotificationState,
    ({ pageLoadingError }) => pageLoadingError
)

export const selectAllAsReadLoading = createSelector(
    selectNotificationState,
    ({ setAllAsReadLoading }) => setAllAsReadLoading
)

export const selectChunks = createSelector(selectPageEntries, (entries) => {
    // create chunks for notifications
    const chunks: NotificationChunk[] = []
    entries.forEach((notification) => {
        const { occurredAt } = notification

        const chunk = chunks.find(
            ({ start, finish }) =>
                -1 < occurredAt.localeCompare(start) &&
                occurredAt.localeCompare(finish) < 1
        )
        if (chunk) {
            chunk.notifications.push(notification)
        } else {
            chunks.push({
                start: dayjs(occurredAt).startOf('month').toISOString(),
                finish: dayjs(occurredAt).endOf('month').toISOString(),
                notifications: [notification],
            })
        }
    })

    return chunks
})

export const selectRemoveEntriesParams = createSelector(
    selectNotificationState,
    ({ removeEntriesParams }) => removeEntriesParams
)
